module.exports = __webpack_public_path__ + "static/media/pencil.11327fe0.svg";